import { render, staticRenderFns } from "./thirdTest.vue?vue&type=template&id=573f31a5&scoped=true"
import script from "./thirdTest.vue?vue&type=script&lang=js"
export * from "./thirdTest.vue?vue&type=script&lang=js"
import style0 from "./thirdTest.vue?vue&type=style&index=0&id=573f31a5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573f31a5",
  null
  
)

export default component.exports